<template>
    <div>
        <table-cadu
          :class="$vuetify.breakpoint.xs ? 'mandatos-mobile': 'mandatos'"
          v-model="selected"
          custom
          nameTab="ans"
          :append-icon="'$vuetify.icons.chevron-down'"
          :showCheck="canEdit"
          :rows="rows"
          :rowsHeader="rowsHeader"
          :items="['05', '10', '15', '20']"
          :elementsPerPageProp="elementsPerPage"
          :pagina="pagina"
          :qtPaginas="qtPaginas"
          :qtResultados="qtResultados"
          :texto="canEdit ? '+ adicionar medida interventiva' : ''"
          :editar="canEdit"
          :ordemProp="ordem"
          :showAnexo="true"
          @change-element="element => changeSelect(element)"
          @change-page="page => changePage(page)"
          @ordena="ordem => ordernaTable(ordem)"
          @clickButton="obj => clickItem(obj)"
          @filtro-click="$emit('filtro-click')"
          @anexar="anexar"
          v-if="!isLoading"
        />
        <component-loading style="height: 256px;" :value="isLoading"/>
    </div>
</template>

<script>
import { EventBus } from '@/services/EventBus/EventBus'
export default {
  props: {
    medidas: {
      type: Object,
      required: false
    },
    role: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      rowsHeader: [
        { text: 'Tipo de Intervenção', icon: 'repeat' },
        { text: 'Número da R.O.', tooltip: 'Número da Resolução Operacional', icon: 'repeat' },
        { text: 'Data D.O.U.', tooltip: 'Data de publicação no Diário Oficial da União', icon: 'repeat' },
        { text: 'Prazo de Validade', icon: 'repeat' },
        { text: 'Status', icon: 'repeat' }
      ],
      rows: this.medidas.conteudo,
      pagina: this.medidas.pagina,
      qtPaginas: this.medidas.qtPaginas,
      qtResultados: this.medidas.qtResultados,
      selected: [],
      tipoOrdenacao: 'dataValidade',

      showButton: false,
      hoverIndex: -1,

      elementsPerPage: '10',
      currentPage: 1,
      ordem: 'desc',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),

      perfilAcesso: this.role,

      isLoading: this.value,
      filtro: 'TODOS',
      tipoIntervencaoId: ''
    }
  },
  beforeMount () {
    this.paginate()
  },
  computed: {
    args () {
      return `ordenacao=${this.tipoOrdenacao}&direcaoOrdenacao=${this.ordem}&tamanhoPagina=${this.elementsPerPage}&pagina=${this.currentPage}&tipoIntervencaoId=${this.tipoIntervencaoId}&vigencia=${this.filtro}`
    },
    canEdit () {
      return this.role === 'admin_brasil' && this.opcaoEditar
    }
  },
  methods: {
    anexar () {
      EventBus.$emit('showAnexo', 'ANS')
    },
    changeSelect (element) {
      this.elementsPerPage = element
      this.currentPage = 1
      this.paginate()
    },
    changePage (page) {
      if (Number(page.currentPage) !== this.currentPage) {
        this.currentPage = Number(page.currentPage)
        this.paginate()
      }
    },
    ordernaTable (obj) {
      const res = () => {
        switch (obj.index) {
          case 0:
            return 'tipoIntervencao.nome'
          case 1:
            return 'sortingResolucaoOperacional'
          case 2:
            return 'dataPublicacao'
          case 3:
            return 'dias'
          case 4:
            return 'dataValidade'
        }
      }
      this.tipoOrdenacao = res()
      this.ordem = obj.ordem
      this.paginate()
    },
    paginate () {
      this.$emit('paginate', this.args)
    },
    hoverRow (index) {
      this.showButton = true
      this.hoverIndex = index
    },
    downRow () {
      this.hoverIndex = -100
      this.showButton = false
    },
    getStatusColor (rowStatus) {
      if (rowStatus === true) {
        return '#B1D34B'
      } else {
        return '#ED1651'
      }
    },
    deleteAll(obj) {
      let delSelect = []
      obj.selected.forEach(item => {
        delSelect.push(item)
      })
      this.$emit('delete-all', delSelect)
    },
    clickItem (obj) {
      this.$emit('typeButton', obj.type)
      const index = obj.index;
      switch (obj.type) {
        case 'delAll':
          this.deleteAll(obj);
          break
        case 'delete':
          this.deleteAll(obj);
          break
        case 'edit':
          this.$emit('edit', index)
          break
        case 'view':
          this.$emit('view', index)
          break
        case 'add':
          this.$emit('add')
          break
      }
    }
  },
  watch: {
    value () {
      this.isLoading = this.value
    },
    medidas () {
      this.rows = this.medidas.conteudo
      this.pagina = this.medidas.pagina
      this.qtPaginas = this.medidas.qtPaginas
      this.qtResultados = this.medidas.qtResultados

      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
.circle-status
    border-radius: 10px
    width: 9px
    height: 9px

.mandatos-mobile > .table-cadu
  padding: 20px 10px !important
  border: none
  border-radius: 0px
  width: 100% !important

.mandatos > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu > .table > table
    width: 100% !important

.mandatos-mobile > .table-cadu > .table > table
    width: 100% !important
</style>
